import React, { useEffect, useState } from "react";
// import axios from "axios";
import { tns } from "tiny-slider/src/tiny-slider";
import "tiny-slider/dist/tiny-slider.css";
import "../assets/css/YoutubeSlider.css";

const YouTubeSlider = () => {

    const [videos, setVideos] = useState([]);

    useEffect(() => {

        fetchVideos();

    }, []);
    const API_URL = process.env.REACT_APP_BKND_URL;
    const fetchVideos = async () => {

        try {

            const response = await fetch(`${API_URL}/get-youtube-videos.php?limit=10`); 
            const data = await response.json();

            if (data.status === "success") {

                setVideos(data.data);

                setTimeout(() => {

                    tns({
                        container: ".youtube-slider-items",
                        items: 1,
                        slideBy: 1,
                        autoplay: true,
                        controls: false,
                        nav: false,
                        autoplayButtonOutput: false,
                        mouseDrag: true,
                        gutter: 10,
                    });

                }, 100);
            }

        } catch (error) {

            console.error(
                "Error fetching videos:",
                error
            );
        }
    };

    return (

        <div className="youtube-slider mt-4">

            <h5 className="mb-3">
                Latest Videos
            </h5>

            <div className="youtube-slider-items">

                {videos.map((video) => (

                    <div key={video.id}>

                        <a
                            href={video.youtube_url}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                                textDecoration: "none",
                                color: "inherit"
                            }}
                        >

                            <img
                                src={video.thumbnail}
                                alt={video.title}
                                className="img-fluid rounded"
                            />

                            <p className="mt-2 small">
                                {video.title}
                            </p>

                        </a>

                    </div>

                ))}

            </div>

        </div>

    );
};

export default YouTubeSlider;
